import { useEffect, useRef, useState } from 'react';

// Both season pages share a latest-request-only lifecycle. The API instance may
// change when the auth provider renders; changing it alone must not refetch.
export const useSeasonReport = ({ api, path, start, end, setStart, setEnd, language }) => {
  const apiRef = useRef(api);
  apiRef.current = api;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (!path) return undefined;
    let active = true;
    const controller = new AbortController();
    setError(null);
    if ((start && end && start > end) || Boolean(start) !== Boolean(end)) {
      setError(language === 'IT' ? 'Seleziona un intervallo di date valido.' : 'Select a valid date range.');
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const timer = setTimeout(() => {
      const url = `${path}?language=${language}` +
        (start && end ? `&start_date=${start}&end_date=${end}` : '');
      apiRef.current.get(url, { signal: controller.signal })
        .then(response => {
          if (!active) return;
          setData(response.data);
          setStart(value => value || response.data.period.start_date);
          setEnd(value => value || response.data.period.end_date);
        })
        .catch(err => {
          if (active && err.code !== 'ERR_CANCELED') {
            setError(err?.response?.data?.detail || (language === 'IT' ? 'Caricamento non riuscito.' : 'Failed to load.'));
          }
        })
        .finally(() => { if (active) setLoading(false); });
    }, 200);
    return () => { active = false; clearTimeout(timer); controller.abort(); };
  }, [path, start, end, language, setStart, setEnd]);
  return { data, loading, error };
};